import { teacherRoutes } from 'src/routes'
import RoleLayout from './RoleLayout'

const TeacherLayout = () => <RoleLayout allowedProfile="Teacher" routes={teacherRoutes} />

export default TeacherLayout
